// // import { localStorage } from "react-native";


// const getUserInfo = async () => {
//     let userId = '';
//     try {
//         userId = await localStorage.getItem('@userToken') ;

//     } catch (error) {
//         // Error retrieving data
//         console.log(error.message);
//     }
//     console.log(userId)
//     return userId;
// }

// export default getUserInfo
const getUserInfo =  () => {
    let userId = '';
    try {
        // Retrieve data from localStorage
        userId =  localStorage.getItem('@userToken');
        if (userId === null) {
            console.log("No user token found");
            return null;  // Return null if no token is found
        }
    } catch (error) {
        // Handle errors
        console.log(error.message);
    }
    return userId;
}

export default getUserInfo;
